var map = {
	"./blog-1.png": "5ee2",
	"./blog-2.png": "1e14",
	"./blog-3.png": "fac7",
	"./blog-4.png": "c656",
	"./comment.jpg": "f3f8",
	"./default-post-img.jpg": "96e1",
	"./facebook.svg": "8f21",
	"./instagram.svg": "257d",
	"./logo.png": "60a3",
	"./logo.svg": "7a2c8",
	"./main-banner.png": "83bb",
	"./theme-default-banner.jpg": "ab48",
	"./theme-second-banner.jpg": "ec8e",
	"./theme-third-banner.jpg": "2f6c",
	"./youtube.svg": "6b60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9857";